import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
  Inbox,
  CalendarMonth,
  Feed,
  Dashboard,
  Receipt,
  Group,
  MapsHomeWork,
  Person,
  FlightLand,
  AccountBalance,
  CleaningServices,
  Hail,
  LocalOffer, // Add this import for the Offers icon
  Pool, // Add Pool icon if not already imported
  Description,
  Language,
  Build, // Add this import for the Tools icon
} from "@mui/icons-material";
import Collapse from "@material-ui/core/Collapse";
import logo from "../../images/rh_logo.png";
import { useNavigate } from "react-router-dom";
import "./MobileSidebar.css";
import LegacySwitcher from "../legacySwitcher/LegacySwitcher";
import LoginCounter from "../loginCounter/LoginCounter";

const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "0.5s",
    }),
  },
  drawerPaper: {
    backgroundColor: "var(--primary-color)", // Ensure this CSS variable is defined
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "0.5s",
    }),
  },
  drawerPaperExpanded: {
    width: "250px", // Set your expanded width
  },
  drawerPaperCollapsed: {
    width: "90px", // Set your collapsed width
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: theme.spacing(0, 1),
    backgroundColor: "var(--tertiary-color)", // Ensure this CSS variable is defined
    ...theme.mixins.toolbar,
  },

  toggleButton: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 100,
  },
  ListItemButton: {
    color: "var(--tertiary-color)", // Ensure this CSS variable is defined
    backgroundColor: "var(--primary-color)", // Ensure this CSS variable is defined
  },
  ListItemButtonActive: {
    color: "white", // Ensure this CSS variable is defined
    backgroundColor: "var(--secondary-color)", // Ensure this CSS variable is defined
  },
  ListItemIcon: {
    color: "var(--tertiary-color)", // Ensure this CSS variable is defined
  },
  ListItemIconActive: {
    color: "white", // Ensure this CSS variable is defined
  },
}));
const MobileSidebar = (props) => {
  const [ticketsSubMenuOpen, setTicketsSubMenuOpen] = useState(false); // State to manage the tickets submenu visibility
  const [arrivalsSubMenuOpen, setArrivalsSubMenuOpen] = useState(false); // State to manage the arrivals submenu visibility
  const [accountingSubMenuOpen, setAccountingSubMenuOpen] = useState(false); // State to manage the accounting submenu visibility
  const [ownerSubMenuOpen, setOwnerSubMenuOpen] = useState(false); // State to manage the accounting submenu visibility
  const [cleaningsSubMenuOpen, setCleaningsSubMenuOpen] = useState(false); // State to manage the cleanings submenu visibility
  const [webSubMenuOpen, setWebSubMenuOpen] = useState(false); // State to manage the web submenu visibility
  const [poolSubMenuOpen, setPoolSubMenuOpen] = useState(false); // State to manage the pool submenu visibility
  const [toolsSubMenuOpen, setToolsSubMenuOpen] = useState(false); // State to manage the tools submenu visibility

  const [isCollapsed, setIsCollapsed] = useState(false); // State to manage the sidebar collapse

  const classes = useStyles({ ticketsSubMenuOpen });
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const handleToggle = () => {
    props.setDrawerOpen(!props.drawerOpen);
  };

  const toggleTicketsSubMenu = () => {
    setTicketsSubMenuOpen(!ticketsSubMenuOpen);
  };

  const toggleArrivalsSubMenu = () => {
    setArrivalsSubMenuOpen(!arrivalsSubMenuOpen);
  };

  const toggleAccountingSubMenu = () => {
    setAccountingSubMenuOpen(!accountingSubMenuOpen);
  };

  const toggleOwnerSubMenu = () => {
    setOwnerSubMenuOpen(!ownerSubMenuOpen);
  };

  const toggleCleaningsSubMenu = () => {
    setCleaningsSubMenuOpen(!cleaningsSubMenuOpen);
  };

  const togglePoolSubMenu = () => {
    setPoolSubMenuOpen(!poolSubMenuOpen);
  };

  const toggleWebSubMenu = () => {
    setWebSubMenuOpen(!webSubMenuOpen);
  };

  const toggleToolsSubMenu = () => {
    setToolsSubMenuOpen(!toolsSubMenuOpen);
  };

  const handleNavigation = (e, path) => {
    // Check if Ctrl key or Command (metaKey) is pressed for onClick events
    if (e.ctrlKey || e.metaKey) {
      // Open in new tab
      window.open(path, "_blank");
      e.preventDefault(); // Prevent default behavior
    } else {
      // Normal navigation
      navigate(path);
    }
  };

  // Separate handler for middle mouse button clicks
  const handleMiddleClick = (e, path) => {
    // Check if middle button is clicked (e.button === 1)
    if (e.button === 1) {
      // Open in new tab
      window.open(path, "_blank");
      e.preventDefault(); // Prevent default behavior
    }
  };

  let menuItems = [
    {
      text: "Dashboard",
      href: "/dashboard",
      icon: <Dashboard />,
      onClick: (e) => {
        handleNavigation(e, "/dashboard");
      },
      onAuxClick: (e) => {
        handleMiddleClick(e, "/dashboard");
      },
    },
    {
      text: "Tickets",
      href: "/tickets",
      icon: <Feed />,
      onClick: () => {
        if (
          isCollapsed &&
          !ticketsSubMenuOpen &&
          !arrivalsSubMenuOpen &&
          !accountingSubMenuOpen &&
          !ownerSubMenuOpen
        ) {
          toggleTicketsSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleTicketsSubMenu();
        }
      },
      submenu: [
        {
          text: "All Tickets",
          href: "/tickets/all",
          onClick: (e) => handleNavigation(e, "/tickets/all"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/all"),
        },
        {
          text: "Assigned To Me",
          href: "/tickets/assigned-to-me",
          onClick: (e) => handleNavigation(e, "/tickets/assigned-to-me"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/assigned-to-me"),
        },
        {
          text: "Created By Me",
          href: "/tickets/created-by-me",
          onClick: (e) => handleNavigation(e, "/tickets/created-by-me"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/created-by-me"),
        },
        {
          text: "In Progress",
          href: "/tickets/on-progress",
          onClick: (e) => handleNavigation(e, "/tickets/on-progress"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/on-progress"),
        },
        {
          text: "Open Tickets",
          href: "/tickets/open",
          onClick: (e) => handleNavigation(e, "/tickets/open"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/open"),
        },
        {
          text: "Completed Tickets",
          href: "/tickets/closed",
          onClick: (e) => handleNavigation(e, "/tickets/completed"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/completed"),
        },
        {
          text: "Archived Tickets",
          href: "/tickets/archived",
          onClick: (e) => handleNavigation(e, "/tickets/archived"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/archived"),
        },
        {
          text: "Settings",
          href: "/tickets/settings",
          onClick: (e) => handleNavigation(e, "/tickets/settings"),
          onAuxClick: (e) => handleMiddleClick(e, "/tickets/settings"),
        },
      ],
    },

    {
      text: "Calendar",
      href: "/calendar",
      icon: <CalendarMonth />,
      onClick: (e) => handleNavigation(e, "/calendar"),
      onAuxClick: (e) => handleMiddleClick(e, "/calendar"),
    },
    {
      text: "Cleanings",
      href: "/actions",
      icon: <CleaningServices />,
      onClick: () => {
        if (isCollapsed && !cleaningsSubMenuOpen) {
          toggleCleaningsSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleCleaningsSubMenu();
        }
      },
      submenu: [
        {
          text: "All Cleanings",
          href: "/actions/all",
          onClick: (e) => handleNavigation(e, "/actions/all"),
          onAuxClick: (e) => handleMiddleClick(e, "/actions/all"),
        },
        {
          text: "Settings",
          href: "/actions/settings",
          onClick: (e) => handleNavigation(e, "/actions/settings"),
          onAuxClick: (e) => handleMiddleClick(e, "/actions/settings"),
        },
      ],
    },
    {
      text: "Arrivals",
      href: "/arrivals",
      icon: <FlightLand />,
      onClick: () => {
        if (
          isCollapsed &&
          !arrivalsSubMenuOpen &&
          !accountingSubMenuOpen &&
          !ticketsSubMenuOpen &&
          !ownerSubMenuOpen
        ) {
          toggleArrivalsSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleArrivalsSubMenu();
        }
      },
      submenu: [
        {
          text: "All Arrivals",
          href: "/arrivals/all",
          onClick: (e) => handleNavigation(e, "/arrivals/all"),
          onAuxClick: (e) => handleMiddleClick(e, "/arrivals/all"),
        },
        {
          text: "My Upcoming Arrivals",
          href: "/arrivals/upcoming",
          onClick: (e) => handleNavigation(e, "/arrivals/upcoming"),
          onAuxClick: (e) => handleMiddleClick(e, "/arrivals/upcoming"),
        },
        {
          text: "Assign Upcoming",
          href: "/arrivals/assign",
          onClick: (e) => handleNavigation(e, "/arrivals/assign"),
          onAuxClick: (e) => handleMiddleClick(e, "/arrivals/assign"),
        },
        {
          text: "Settings",
          href: "/arrivals/settings",
          onClick: (e) => handleNavigation(e, "/arrivals/settings"),
          onAuxClick: (e) => handleMiddleClick(e, "/arrivals/settings"),
        },
      ],
    },
    {
      text: "Accounting",
      href: "/accounting",
      icon: <AccountBalance />,
      onClick: () => {
        if (
          isCollapsed &&
          !accountingSubMenuOpen &&
          !ticketsSubMenuOpen &&
          !arrivalsSubMenuOpen &&
          !ownerSubMenuOpen
        ) {
          toggleAccountingSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleAccountingSubMenu();
        }
      },
      submenu: [
        {
          text: "All Transactions",
          href: "/accounting/all",
          onClick: (e) => handleNavigation(e, "/accounting/all"),
          onAuxClick: (e) => handleMiddleClick(e, "/accounting/all"),
        },
        {
          text: "User Transactions",
          href: "/accounting/user",
          onClick: (e) => handleNavigation(e, "/accounting/see-users"),
          onAuxClick: (e) => handleMiddleClick(e, "/accounting/see-users"),
        },

        {
          text: "Owner Transactions",
          href: "/owner-transactions",
          onClick: (e) => handleNavigation(e, "/owner-transactions"),
          onAuxClick: (e) => handleMiddleClick(e, "/owner-transactions"),
        },
        {
          text: "Accounting Settings",
          href: "/accounting/settings",
          onClick: (e) => handleNavigation(e, "/accounting/settings"),
          onAuxClick: (e) => handleMiddleClick(e, "/accounting/settings"),
        },
      ],
    },
    {
      text: "Chat",
      href: "/inbox",
      icon: <Inbox />,
      onClick: (e) => handleNavigation(e, "/inbox"),
      onAuxClick: (e) => handleMiddleClick(e, "/inbox"),
    },
    {
      text: "Reservations",
      href: "/reservations",
      icon: <Receipt />,
      onClick: (e) => handleNavigation(e, "/reservations"),
      onAuxClick: (e) => handleMiddleClick(e, "/reservations"),
    },
    {
      text: "Properties",
      href: "/properties",
      icon: <MapsHomeWork />,
      onClick: (e) => handleNavigation(e, "/properties"),
      onAuxClick: (e) => handleMiddleClick(e, "/properties"),
    },
    {
      text: "Groups",
      href: "/groups",
      icon: <Group />,
      onClick: (e) => handleNavigation(e, "/groups"),
      onAuxClick: (e) => handleMiddleClick(e, "/groups"),
    },
    {
      text: "Users",
      href: "/users",
      icon: <Person />,
      onClick: (e) => handleNavigation(e, "/users"),
      onAuxClick: (e) => handleMiddleClick(e, "/users"),
    },
    {
      text: "Owners",
      href: "/owners",
      icon: <Hail />,
      onClick: () => {
        if (
          isCollapsed &&
          !ownerSubMenuOpen &&
          !ticketsSubMenuOpen &&
          !arrivalsSubMenuOpen &&
          !accountingSubMenuOpen
        ) {
          toggleOwnerSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleOwnerSubMenu();
        }
      },
      submenu: [
        {
          text: "Add Owner",
          href: "/owner-add",
          onClick: (e) => handleNavigation(e, "/owner-add"),
          onAuxClick: (e) => handleMiddleClick(e, "/owner-add"),
        },
        {
          text: "Edit Owner",
          href: "/owner-edit",
          onClick: (e) => handleNavigation(e, "/owner-edit"),
          onAuxClick: (e) => handleMiddleClick(e, "/owner-edit"),
        },
        {
          text: "Preview Owner",
          href: "/owner-preview",
          onClick: (e) => handleNavigation(e, "/owner-preview"),
          onAuxClick: (e) => handleMiddleClick(e, "/owner-preview"),
        },
      ],
    },

    {
      text: "Website Settings",
      href: "/website-settings",
      icon: <Language />,
      onClick: () => {
        if (isCollapsed && !webSubMenuOpen) {
          toggleWebSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleWebSubMenu();
        }
      },
      submenu: [
        {
          text: "Locations Map",
          href: "/locations-map",
          onClick: (e) => handleNavigation(e, "/locations-map"),
          onAuxClick: (e) => handleMiddleClick(e, "/locations-map"),
        },
        {
          text: "Property Order",
          href: "/property-order",
          onClick: (e) => handleNavigation(e, "/property-order"),
          onAuxClick: (e) => handleMiddleClick(e, "/property-order"),
        },
        {
          text: "Location Order",
          href: "/location-order",  
          onClick: (e) => handleNavigation(e, "/location-order"),
          onAuxClick: (e) => handleMiddleClick(e, "/location-order"),
        },

        {
          text: "Property Taxes",
          href: "/properties/taxes",
          onClick: (e) => handleNavigation(e, "/properties/taxes"),
          onAuxClick: (e) => handleMiddleClick(e, "/properties/taxes"),
        },
        {
          text: "Offers",
          href: "/offers",
          onClick: (e) => handleNavigation(e, "/offers"),
          onAuxClick: (e) => handleMiddleClick(e, "/offers"),
        },
      ],
    },

    {
      text: "Tools",
      href: "/tools",
      icon: <Build />,
      onClick: () => {
        if (isCollapsed && !toolsSubMenuOpen) {
          toggleToolsSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          toggleToolsSubMenu();
        }
      },
      submenu: [
        {
          text: "WebP Converter",
          href: "/webp-converter",
          onClick: (e) => handleNavigation(e, "/webp-converter"),
          onAuxClick: (e) => handleMiddleClick(e, "/webp-converter"),
        },
        {
          text: "Image Transformer",
          href: "/image-transformer",
          onClick: (e) => handleNavigation(e, "/image-transformer"),
          onAuxClick: (e) => handleMiddleClick(e, "/image-transformer"),
        },
      ],
    },

    {
      text: "Contracts",
      href: "/contracts",
      icon: <Description />,
      onClick: (e) => handleNavigation(e, "/contracts"),
      onAuxClick: (e) => handleMiddleClick(e, "/contracts"),
    },
    {
      text: "Pools",
      href: "/pools",
      icon: <Pool />,
      onClick: () => {
        if (
          isCollapsed &&
          !poolSubMenuOpen &&
          !ownerSubMenuOpen &&
          !ticketsSubMenuOpen &&
          !arrivalsSubMenuOpen &&
          !accountingSubMenuOpen
        ) {
          togglePoolSubMenu();
          handleToggle();
        } else if (isCollapsed) {
          handleToggle();
        } else {
          togglePoolSubMenu();
        }
      },
      submenu: [
        {
          text: "All Pools",
          href: "/pools/all",
          onClick: (e) => handleNavigation(e, "/pools/all"),
          onAuxClick: (e) => handleMiddleClick(e, "/pools/all"),
        },
        {
          text: "Pool Settings",
          href: "/pools/settings",
          onClick: (e) => handleNavigation(e, "/pools/settings"),
          onAuxClick: (e) => handleMiddleClick(e, "/pools/settings"),
        },
      ],
    },
  ];
  
  const filterMenuItems = (menuItems, user) => {
    return menuItems.reduce((acc, item) => {
      if (item.submenu) {
        if (
          item.text === "Accounting" &&
          !user.permissions.canDecideTransaction
        )
          return acc;

        const filteredSubmenu = item.submenu.filter((subItem) => {
          if (
            subItem.text === "All Tickets" &&
            !user.permissions.canViewAllTickets
          )
            return false;
          if (
            subItem.text === "Settings" &&
            !user.permissions.canEditTicketSettings
          )
            return false;
          if (
            subItem.text === "Created By Me" &&
            !user.permissions.canCreateTicket
          )
            return false;
          if (
            subItem.text === "Open Tickets" &&
            !user.permissions.canViewOpenTickets
          )
            return false;
          if (
            subItem.text === "Completed Tickets" &&
            !user.permissions.canViewCompletedTickets
          )
            return false;
          if (subItem.text === "Arrivals" && !user.permissions.canViewArrival)
            return false;
          if (
            subItem.text === "All Arrivals" &&
            !user.permissions.canViewAllArrivals
          )
            return false;
          if (
            subItem.text === "My Upcoming Arrivals" &&
            !user.permissions.canViewArrival
          )
            return false;
          if (
            subItem.text === "Assign Upcoming" &&
            !user.permissions.canAssignArrival
          )
            return false;

          if (
            subItem.text === "Accounting Settings" &&
            !user.permissions.canEditTransactionSettings
          )
            return false;

          if (subItem.text === "Add Owner" && !user.permissions.canCreateOwner)
            return false;

          if (subItem.text === "Edit Owner" && !user.permissions.canEditOwner)
            return false;

          if (
            subItem.text === "Preview Owner" &&
            !user.permissions.canCreateOwner
          )
            return false;

          if (
            subItem.text === "All Cleanings" &&
            !user.permissions.canAssignCleaning
          )
            return false;

          if (
            subItem.text === "Settings" &&
            !user.permissions.canAssignCleaning
          )
            return false;

          if (
            subItem.text === "Pool Settings" &&
            !user.permissions.canAddPoolOption
          )
            return false;

          if (
            subItem.text === "All Pools" &&
            !user.permissions.canAddPoolAction
          )
            return false;

          if (
            subItem.text === "Locations Map" &&
            !user.permissions.canViewLocationsMap
          )
            return false;

          if (subItem.text === "Offers" && !user.permissions.canViewOffers)
            return false;

          if (
            subItem.text === "Property Order" &&
            !user.permissions.canEditPropertyOrder
          )
            return false;
          if (
            subItem.text === "Location Order" &&
            !user.permissions.canEditLocationOrder
          )
            return false;
          if (
            subItem.text === "Property Taxes" &&
            !user.permissions.canEditPropertyTaxes
          )
            return false;

          return true;
        });

        if (filteredSubmenu.length > 0) {
          acc.push({ ...item, submenu: filteredSubmenu });
        }
      } else {
        if (
          item.text === "Accounting" &&
          !user.permissions.canDecideTransaction
        ) {
          return acc;
        }
        if (item.text === "Groups" && !user.permissions.canCreateGroup) {
          return acc;
        }
        if (item.text === "Users" && !user.permissions.canChangePermissions) {
          return acc;
        }
        if (item.text === "Properties" && !user.permissions.canViewProperty) {
          return acc;
        }
        if (
          item.text === "Reservations" &&
          !user.permissions.canViewReservation
        ) {
          return acc;
        }

        if (
          item.text === "Owners" &&
          !user.permissions.canCreateOwner &&
          !user.permissions.canEditOwner &&
          !user.permissions.canViewOwner
        ) {
          return acc;
        }

        if (item.text === "Calendar" && !user.permissions.canAssignCleaning) {
          return acc;
        }
        if (item.text === "Cleanings" && !user.permissions.canAssignCleaning) {
          return acc;
        }

        // Add permission check for Contracts
        if (item.text === "Contracts" && !user.permissions.canViewContracts) {
          return acc;
        }

        acc.push(item);
      }
      return acc;
    }, []);
  };

  menuItems = filterMenuItems(menuItems, user);

  return (
    <div className="sidebar">
      <Drawer
        anchor="left"
        className={classes.drawer}
        open={props.drawerOpen}
        onClose={handleToggle}
        classes={{
          paper: `${classes.drawerPaper} ${classes.drawerPaperExpanded}`,
        }}
      >
        <List>
          {menuItems.map((item, index) => (
            <div key={index}>
              <Tooltip
                key={item.text}
                title={item.text}
                placement="right"
                PopperProps={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -10],
                      },
                    },
                  ],
                  sx: {
                    "& .MuiTooltip-tooltip": {
                      fontSize: "14px",
                      backgroundColor: "var(--tertiary-color)",
                    },
                  },
                }}
              >
                <ListItem
                  button
                  key={item.text}
                  onClick={item.onClick}
                  className={
                    item.href === window.location.pathname ||
                    item.submenu?.some(
                      (subItem) => subItem.href === window.location.pathname
                    )
                      ? classes.ListItemButtonActive
                      : classes.ListItemButton
                  }
                  style={{
                    paddingLeft: "10px",
                    transition: "all 0.5s",
                  }}
                >
                  <ListItemIcon
                    className={
                      item.href === window.location.pathname ||
                      item.submenu?.some(
                        (subItem) => subItem.href === window.location.pathname
                      )
                        ? classes.ListItemIconActive
                        : classes.ListItemIcon
                    }
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    style={{
                      visibility: "visible",
                      opacity: "1",
                      transition: "all 0.5s",
                    }}
                  />
                  {item.submenu &&
                    !isCollapsed &&
                    (item.text === "Tickets" ? (
                      ticketsSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Arrivals" ? (
                      arrivalsSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Accounting" ? (
                      accountingSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Owners" ? (
                      ownerSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Cleanings" ? (
                      cleaningsSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Pools" ? (
                      poolSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Website Settings" ? (
                      webSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : item.text === "Tools" ? (
                      toolsSubMenuOpen ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : null)}
                </ListItem>
              </Tooltip>
              {item.submenu && (
                <Collapse
                  in={
                    item.text === "Tickets"
                      ? ticketsSubMenuOpen
                      : item.text === "Arrivals"
                      ? arrivalsSubMenuOpen
                      : item.text === "Accounting"
                      ? accountingSubMenuOpen
                      : item.text === "Owners"
                      ? ownerSubMenuOpen
                      : item.text === "Cleanings"
                      ? cleaningsSubMenuOpen
                      : item.text === "Pools"
                      ? poolSubMenuOpen
                      : item.text === "Website Settings"
                      ? webSubMenuOpen
                      : item.text === "Tools"
                      ? toolsSubMenuOpen
                      : false
                  }
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.submenu.map((subItem) => (
                      <Tooltip
                        title={subItem.text}
                        placement="right"
                        PopperProps={{
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -10],
                              },
                            },
                          ],
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              fontSize: "14px",
                              backgroundColor: "var(--tertiary-color)",
                            },
                          },
                        }}
                      >
                        <ListItem
                          button
                          key={subItem.text}
                          className={
                            subItem.href === window.location.pathname
                              ? classes.ListItemButtonActive
                              : classes.ListItemButton
                          }
                          onClick={subItem.onClick}
                        >
                          <ListItemText inset primary={subItem.text} />
                        </ListItem>
                      </Tooltip>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}
          {user.permissions.canViewLegacy && (
            <ListItem
              style={{
                backgroundColor: "var(--tertiary-color)",
              }}
            >
              <ListItemIcon>
                <LegacySwitcher />
              </ListItemIcon>
              <ListItemText
                primary="Legacy"
                style={{
                  color: "var(--primary-color)",
                }}
              >
                Legacy Mode
              </ListItemText>
            </ListItem>
          )}

          <ListItem
            style={{
              backgroundColor: "var(--tertiary-color)",
            }}
          >
            <div className="sidebar__login__counter">
              <LoginCounter />
            </div>
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default MobileSidebar;
